var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import { ParcelaImovel } from '../../../../../model/ParcelaImovel';
import { ModoCRUDEnum } from '../../../../../model/enums/ModoCRUDEnum';
import { AuthConstants } from '../../../../../util/auth-constants';
import { useCacheStore } from '../../../../../stores/CacheStore';
import { prettyArea } from '../DadosImovelUsucapiaoRural';
import { hasErrors, hasValue } from '../../../../utils/ValidationUtils';
import { generateErrorFields, handleScrollTop, useRequerimentoContext, } from '../../context/RequerimentoContext';
import { DefaultCard } from '../../../../../components/DefaultCard';
import { SimpleTable } from '../../../../../components/SimpleTable/SimpleTable';
import { DadosBasicosParcela } from '../../common/DadosBasicosParcela';
import { DadosParcelaMunicipio } from '../../../../../components/DadosParcelaMunicipio';
import { ParcelaImovelCadastro } from '../../common/ParcelaImovelCadastro';
import { CustomRadioGroup } from '../../../../../components/Forms/CustomRadioGroup';
import { SessaoSIGEF } from '../../../../../components/SessaoSIGEF';
import { UfEnum } from '../../../../../model/enums/UfEnum';
import { ShowContent } from '../../../../../components/ShowContent';
import { useTheme } from '@mui/system';
export var DadosImoveAverbTitJudicial = function (_a) {
    var _b;
    var requerimentoFieldErrorChange = _a.requerimentoFieldErrorChange, requerimentoFieldError = _a.requerimentoFieldError, requerimento = _a.requerimento, onValidate = _a.onValidate, onChange = _a.onChange;
    //region Constants
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down('md'));
    var _c = useRequerimentoContext(), recoverData = _c.recoverData, defaultHandleAddParcelaImovel = _c.defaultHandleAddParcelaImovel, setNotification = _c.setNotification, getStatusSigef = _c.getStatusSigef;
    var _d = useState(new ParcelaImovel()), parcelaImovel = _d[0], setParcelaImovel = _d[1];
    var _e = useState(false), isDisabledBySigef = _e[0], setIsDisabledBySigef = _e[1];
    var _f = useState(null), indexSelecionado = _f[0], setIndexSelecionado = _f[1];
    var _g = useState(false), sigefIsOnline = _g[0], setSigefIsOnline = _g[1];
    var _h = useState(true), usarApiSigef = _h[0], setUsarApiSigef = _h[1];
    var _j = useState(ModoCRUDEnum.CREATE), modo = _j[0], setModo = _j[1];
    var _k = useState({}), fieldError = _k[0], setFieldError = _k[1];
    //endregion
    //region Hooks
    useEffect(function () {
        var _a, _b;
        recoverData(requerimento, setParcelaImovel, AuthConstants.PARCELA_IMOVEL_CACHE);
        var possuiSigef = (_b = (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a.some(function (it) { return !!it.codigoSIGEF; })) !== null && _b !== void 0 ? _b : true;
        setUsarApiSigef(possuiSigef);
    }, []);
    useEffect(function () {
        useCacheStore.getState().setCache(AuthConstants.PARCELA_IMOVEL_CACHE, __assign(__assign({}, parcelaImovel), { requerimentoId: requerimento === null || requerimento === void 0 ? void 0 : requerimento.id }));
    }, [parcelaImovel]);
    useEffect(function () {
        recoverData(requerimento, setParcelaImovel, AuthConstants.PARCELA_IMOVEL_CACHE);
        var parcelas = (requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) || [];
        if (parcelas.length > 0) {
            var possuiSigef = parcelas.some(function (it) { return !!it.codigoSIGEF; });
            setUsarApiSigef(possuiSigef);
        }
    }, []);
    useEffect(function () {
        if (onValidate)
            onValidate(handleValidate);
    }, [parcelaImovel, usarApiSigef, fieldError, requerimento]);
    //endregion
    //region Handles
    var columns = useMemo(function () {
        var firstColumn = usarApiSigef
            ? { label: 'Código SIGEF da Parcela', value: 'codigoSIGEF' }
            : { label: 'Denominação da Parcela', value: 'denominacao' };
        var baseColumns = [
            firstColumn,
            { label: 'Código INCRA do RT', value: 'codigoIncra' },
            { label: 'Área(HA)', value: 'area' },
            { label: 'Município Atual', value: 'municipio' },
        ];
        if (usarApiSigef) {
            baseColumns.push({ label: 'Status SIGEF', value: 'statusSigef' });
        }
        return baseColumns;
    }, [usarApiSigef]);
    var isEdit = useMemo(function () {
        return modo === ModoCRUDEnum.UPDATE;
    }, [modo]);
    var isPecasTecnicasDisabled = useMemo(function () {
        var _a, _b;
        return ((_b = (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0;
    }, [(_b = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _b === void 0 ? void 0 : _b.length]);
    var values = useMemo(function () {
        var _a;
        return (((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a.map(function (parcela) {
            var _a, _b, _c, _d, _e, _f, _g;
            var baseValues = {
                codigoSIGEF: (_a = parcela === null || parcela === void 0 ? void 0 : parcela.codigoSIGEF) !== null && _a !== void 0 ? _a : '',
                denominacao: (_b = parcela === null || parcela === void 0 ? void 0 : parcela.denominacao) !== null && _b !== void 0 ? _b : '',
                codigoIncra: (_d = (_c = parcela === null || parcela === void 0 ? void 0 : parcela.responsavelTecnico) === null || _c === void 0 ? void 0 : _c.codigoIncra) !== null && _d !== void 0 ? _d : '',
                area: (_e = prettyArea(parcela === null || parcela === void 0 ? void 0 : parcela.area)) !== null && _e !== void 0 ? _e : '',
                municipio: (_g = (_f = parcela === null || parcela === void 0 ? void 0 : parcela.municipio) === null || _f === void 0 ? void 0 : _f.nome) !== null && _g !== void 0 ? _g : '',
            };
            if (usarApiSigef) {
                var statusSigef = getStatusSigef(parcela, sigefIsOnline, usarApiSigef);
                baseValues['statusSigef'] = statusSigef;
            }
            return baseValues;
        })) || []);
    }, [requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel, usarApiSigef, getStatusSigef, sigefIsOnline]);
    var handleAdd = function () {
        var _a;
        var isValid = handleValidateParcela();
        if (isValid) {
            var parcelas_1 = (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) !== null && _a !== void 0 ? _a : [];
            var fieldsToCompare = ['denominacao'];
            if (parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.codigoSIGEF)
                fieldsToCompare.push('codigoSIGEF');
            var hasDuplicate = fieldsToCompare.some(function (campo) {
                return parcelas_1.some(function (parcela, index) {
                    if (indexSelecionado != null && index === indexSelecionado)
                        return false;
                    return ((parcela === null || parcela === void 0 ? void 0 : parcela[campo]) ===
                        (parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel[campo]));
                });
            });
            if (!hasDuplicate) {
                defaultHandleAddParcelaImovel({
                    indexSelecionadoState: [indexSelecionado, setIndexSelecionado],
                    valueState: [parcelaImovel, setParcelaImovel],
                    valido: isValid,
                    requerimentoState: [requerimento, onChange],
                    modoState: [modo, setModo],
                    fieldErrorState: [fieldError, setFieldError],
                    disableState: [isDisabledBySigef, setIsDisabledBySigef],
                    sigefIsOnline: sigefIsOnline,
                });
                if (usarApiSigef) {
                    if (sigefIsOnline) {
                        setNotification({
                            open: true,
                            message: 'Parcela inserida e validada com sucesso via SIGEF!',
                            severity: 'success',
                            duration: 3000,
                            vertical: 'top',
                        });
                    }
                    else {
                        setNotification({
                            open: true,
                            message: '⚠️ Parcela inserida sem validação automática. A API SIGEF está offline. Os dados inseridos ficarão pendentes de verificação pelo INTERMAT.',
                            severity: 'warning',
                            duration: 5000,
                            vertical: 'top',
                        });
                    }
                }
                else {
                    setNotification({
                        open: true,
                        message: 'Parcela inserida com sucesso em modo convencional!',
                        severity: 'success',
                        duration: 3000,
                        vertical: 'top',
                    });
                }
            }
            else {
                defaultHandleAddParcelaImovel({
                    indexSelecionadoState: [indexSelecionado, setIndexSelecionado],
                    valueState: [parcelaImovel, setParcelaImovel],
                    valido: isValid,
                    requerimentoState: [requerimento, onChange],
                    modoState: [modo, setModo],
                    fieldErrorState: [fieldError, setFieldError],
                    sigefIsOnline: sigefIsOnline,
                });
            }
        }
    };
    var handleValidate = function () {
        var _a;
        var isEmpty = ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a.length) === 0;
        if (requerimentoFieldErrorChange) {
            requerimentoFieldErrorChange(__assign(__assign({}, requerimentoFieldError), { parcelasImovelError: isEmpty
                    ? 'Ao menos uma parcela do imóvel deve ser informada.'
                    : '' }));
        }
        return !isEmpty;
    };
    var handleParcelaChange = function (_parcelaImovel) {
        setParcelaImovel(_parcelaImovel);
    };
    var handleValidateParcela = function () {
        var _a;
        var rt = parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.responsavelTecnico;
        var pf = rt === null || rt === void 0 ? void 0 : rt.pessoaFisica;
        var temSocial = (_a = pf === null || pf === void 0 ? void 0 : pf.informarNomeSocial) !== null && _a !== void 0 ? _a : false;
        var _parcelaErrorField = [
            {
                key: 'codigoSIGEFError',
                condition: usarApiSigef && sigefIsOnline
                    ? !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.codigoSIGEF)
                    : false,
            },
            {
                key: 'denominacaoError',
                condition: !usarApiSigef || !sigefIsOnline
                    ? !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.denominacao)
                    : false,
            },
            {
                key: 'cpfError',
                condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.cpf),
            },
            {
                key: 'nomeError',
                condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.nome),
            },
            {
                key: 'emailError',
                condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.email),
            },
            {
                key: 'cepError',
                condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.cep),
            },
            {
                key: 'celularError',
                condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.celular),
            },
            {
                key: 'estadoError',
                condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.estado),
            },
            {
                key: 'municipioError',
                condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.municipio),
            },
            {
                key: 'bairroError',
                condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.bairro),
            },
            {
                key: 'ufConselhoClasseError',
                condition: !hasValue(rt === null || rt === void 0 ? void 0 : rt.ufConselhoClasse),
            },
            {
                key: 'conselhoClasseError',
                condition: !hasValue(rt === null || rt === void 0 ? void 0 : rt.conselhoClasse),
            },
            {
                key: 'numeroRegistroError',
                condition: !hasValue(rt === null || rt === void 0 ? void 0 : rt.numeroRegistro),
            },
            {
                key: 'codigoIncraError',
                condition: !hasValue(rt === null || rt === void 0 ? void 0 : rt.codigoIncra),
            },
            {
                key: 'numeroTituloDefinitivoError',
                condition: !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.numeroTituloDefinitivo),
            },
            {
                key: 'municipioAtualError',
                condition: !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.municipio),
            },
            { key: 'codigoArtError', condition: !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.codigoArt) },
            { key: 'areaError', condition: !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.area) },
            {
                key: 'enderecoError',
                condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.endereco),
            },
            {
                key: 'numeroError',
                condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.numero),
            },
            {
                key: 'nomeSocialError',
                condition: temSocial && !hasValue(pf === null || pf === void 0 ? void 0 : pf.nomeSocial),
            },
        ];
        var _parcelaFieldError = generateErrorFields(_parcelaErrorField, __assign({}, fieldError));
        setFieldError(_parcelaFieldError);
        return !hasErrors(_parcelaFieldError);
    };
    var onHandleRemoveItem = function (index) {
        if (!(requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel))
            return;
        var _parcelas = requerimento.parcelasImovel.filter(function (it) { return it !== requerimento.parcelasImovel[index]; });
        if (onChange) {
            onChange(__assign(__assign({}, requerimento), { parcelasImovel: _parcelas }));
        }
    };
    var onHandleEdit = function (index) {
        if ((requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) &&
            index >= 0 &&
            index < (requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel.length)) {
            var parcela = requerimento.parcelasImovel[index];
            setUsarApiSigef(!!(parcela === null || parcela === void 0 ? void 0 : parcela.codigoSIGEF));
            handleParcelaChange(__assign({}, parcela));
            setFieldError({});
            setModo(ModoCRUDEnum.UPDATE);
            setIndexSelecionado(index);
            handleScrollTop();
        }
    };
    var handleChangePecas = function (event) {
        setUsarApiSigef(event.target.value === 'true');
        if (isDisabledBySigef)
            setIsDisabledBySigef(false);
    };
    var table = useCallback(function () {
        var _a;
        return (_jsx(DefaultCard, __assign({ title: '' }, { children: _jsx(SimpleTable, { error: (_a = requerimentoFieldError === null || requerimentoFieldError === void 0 ? void 0 : requerimentoFieldError.parcelasImovelError) !== null && _a !== void 0 ? _a : '', onHandleRemoveItem: onHandleRemoveItem, emptyText: "Nenhuma Parcela Inserida", onHandleEdit: onHandleEdit, indexMark: indexSelecionado !== null && indexSelecionado !== void 0 ? indexSelecionado : undefined, showOptions: true, columns: columns, values: values }) })));
    }, [
        requerimentoFieldError === null || requerimentoFieldError === void 0 ? void 0 : requerimentoFieldError.parcelasImovelError,
        values,
        columns,
        indexSelecionado,
    ]);
    var topChildren = useCallback(function () {
        return (_jsx(DadosBasicosParcela, { isDisabledBySigef: isDisabledBySigef, onChange: handleParcelaChange, parcelaImovel: parcelaImovel, requerimento: requerimento, usarApiSigef: usarApiSigef, fieldError: fieldError, uf: UfEnum.MT, modo: modo }));
    }, [parcelaImovel, fieldError, usarApiSigef, requerimento, modo, isDisabledBySigef]);
    var customButtom = function () {
        return (_jsx(Box, __assign({ sx: {
                display: 'flex',
                justifyContent: 'center',
                gap: 1,
                marginTop: 2,
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: 'center',
            } }, { children: _jsx(Button, __assign({ color: "primary", variant: "outlined", onClick: handleAdd, fullWidth: isMobile, size: isMobile ? 'large' : 'medium' }, { children: "".concat(isEdit ? 'Alterar' : 'Incluir', " Parcela ").concat(usarApiSigef ? 'SIGEF' : '') })) })));
    };
    var title = useMemo(function () {
        return usarApiSigef
            ? 'Informe a(s) parcela(s) do imóvel Rural em peças técnicas SIGEF'
            : 'Informe a(s) parcela(s) do Imóvel Rural em peças técnicas convencionais';
    }, [usarApiSigef]);
    //endregion
    return (_jsxs(_Fragment, { children: [_jsx(DadosParcelaMunicipio, { onChange: function (_parcelaImovel) { return handleParcelaChange(__assign({}, _parcelaImovel)); }, subTitle: 'Informe a(s) parcela(s) do imóvel Rural em peças técnicas SIGEF', parcelaImovel: parcelaImovel, isDisabledBySigef: isDisabledBySigef, displayMode: "onlyLivroFields", title: 'Dados da Parcela', fieldError: fieldError, showMunicipios: false }), _jsx(DefaultCard, __assign({ title: "", style: { padding: '31px' } }, { children: _jsx(CustomRadioGroup, { value: "".concat(usarApiSigef || false), onChange: function (event) { return handleChangePecas(event); }, options: [
                        {
                            value: 'false',
                            label: 'Desejo utilizar Peças Técnicas Convencionais',
                        },
                        { value: 'true', label: 'Desejo utilizar Peças Técnicas do SIGEF' },
                    ], label: "Pe\u00E7as T\u00E9cnicas ? ", name: "usar_api-sigef", disabled: isEdit || isPecasTecnicasDisabled, required: true, collumn: true }) })), _jsx(ShowContent, __assign({ show: usarApiSigef }, { children: _jsx(SessaoSIGEF, { sigefIsOnline: sigefIsOnline, setSigefIsOnline: setSigefIsOnline }) })), _jsx(ParcelaImovelCadastro, __assign({ onChange: function (value) { return handleParcelaChange(__assign({}, value)); }, onFieldErrorChange: function (err) { return setFieldError(__assign({}, err)); }, parcelaImovel: parcelaImovel, customButtom: customButtom(), enviarPecasTecInpt: true, showEnvPcsTecCard: false, fieldError: fieldError, showBtnAdd: false, table: table(), isEdit: isEdit, isView: false }, { children: _jsx(DadosParcelaMunicipio, { onChange: function (_parcelaImovel) { return handleParcelaChange(__assign({}, _parcelaImovel)); }, parcelaImovel: parcelaImovel, isDisabledBySigef: isDisabledBySigef, displayMode: "hideLivroFields", topChildren: topChildren(), fieldError: fieldError, showMunicipios: false, title: title }) }))] }));
};
